import styled from 'styled-components';

import { Layout } from '@components/formStyles';

export const StyledLayout = styled(Layout)`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin-left: 15px;
    margin-right: 15px;
    width: 100%;
  }
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  justify-content: center;
  align-items: center;
  height: 396px;
  position: relative;
  margin-top: 40px;
  margin-bottom: 20px;
  width: 100%;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.WIDE_DESKTOP})`} {
    margin-top: 10px;
    margin-botom: 10px;
    padding: 10px;
    height: 191px;
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 20px;
  gap: 20px;
  & > div {
    all: revert;
  }
  @media ${`(max-width: 960px)`} {
    grid-template-columns: 1fr;
    gap: 15px 0;
    margin-bottom: 20px;
  }
`;

export const Title = styled.h1`
  font-size: 36px;
  font-weight: 600;
  margin-top: -10px;

  color: ${({ theme }) => theme.palette.darkGrey};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.WIDE_DESKTOP})`} {
    font-size: 24px;
  }
`;
export const Options = styled.h1`
  font-size: 36px;
  font-weight: 600;
  margin-top: -7px;

  color: ${({ theme }) => theme.palette.darkGrey};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.WIDE_DESKTOP})`} {
    font-size: 24px;
  }
`;

export const BannerSkeletonWrapper = styled.div`
  margin: 0 auto 20px auto;
  width: fit-content;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.WIDE_DESKTOP})`} {
    margin: 0 0 10px 0;
  }
`;
export const TitleOptions = styled.h1`
  font-size: 36px;
  font-weight: 600;
  margin-top: -10px;

  color: ${({ theme }) => theme.palette.darkGrey};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.WIDE_DESKTOP})`} {
    font-size: 24px;
  }
`;
export const TitleOptionsMobile = styled.h1`
  font-size: 36px;
  font-weight: 600;
  margin-top: -7px;

  color: ${({ theme }) => theme.palette.darkGrey};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.WIDE_DESKTOP})`} {
    font-size: 24px;
  }
`;
